import React from 'react'

export default function UserPage() {
    return (
        <div>
            user
        </div>
    )
}
